import React, { Component } from 'react';
import styled from 'styled-components';
import img from '../../images/instore/revieve-logo.svg';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import media from './MediaQueries';
import { translate } from 'react-polyglot';

const StyledWrapper = styled.div`
  z-index: 10;
  width: 100%;
  max-width: 992px;
  padding: 0 30px;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  color: white;
  :not(.revieve-header-0) {
    ${media.phone`
      header {
        display: none;
      }
    `}
  }
`;

const StyledHeader = styled.header`
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 60px;
  .logo {
    width: 200px;
    height: 60px;
    background-image: url(${props => props.logoImg});
    background-repeat: no-repeat;
    background-position: left center;
    background-size: ${props => (props.customLogo ? 'contain' : 'auto')};
    ${media.phone`
      width: 120px;
    `}
  }
  .secondaryLogo {
    background-image: url(${props => props.secondaryLogoImg});
    background-repeat: no-repeat;
    background-position: rigth center;
    background-size: 'contain';
  }
  h1 {
    font-size: 18px;
    font-weight: 400;
    color: white;
    text-align: right;
    ${media.phone`
      font-size: 14px;
      font-weight: 700;
    `}
  }
`;
const StyledDiv = styled.div`
  height: 60px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

const StyledBackIcon = styled.div`
  height: 60px;
  display: flex;
  align-items: center;
  cursor: pointer;
  &:active {
    outline: none;
    border: none;
    background: none;
  }
`;

const StyledResetButton = styled.button`
  cursor: pointer;
  width: 140px;
  height: 44px;
  background-color: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  color: white;
  font-size: 16px;
  font-weight: 500;
  transition: background-color 0.35s ease-in;
  @media (min-width: 320px) and (max-width: 736px) {
    background: none;
    border: none;
    text-align: right;
  }
  &:active {
    background-color: rgba(30, 144, 255, 0.3);
  }
`;

class Header extends Component {
  render = () => {
    const { navigation, navigationText, startOver, prevPage, pageIndex, headerConfig, t } = this.props;
    return (
      <StyledWrapper className={'revieve-header revieve-header-' + pageIndex}>
        <StyledHeader
          logoImg={headerConfig && headerConfig.logo ? headerConfig.logo : img}
          secondaryLogoImg={headerConfig && headerConfig.secondaryLogo}
          customLogo={headerConfig && headerConfig.logo}
        >
          <div className="logo"></div>
          {(!headerConfig || !headerConfig.secondaryLogo) && <h1>{t('digital_advisor')}</h1>}
          {headerConfig && headerConfig.secondaryLogo && <h1 className="logo secondaryLogo">&nbsp;</h1>}
        </StyledHeader>

        <ReactCSSTransitionGroup
          transitionName="headerSlide"
          transitionAppear={false}
          transitionEnter={true}
          transitionLeave={true}
          transitionAppearTimeout={1500}
          transitionLeaveTimeout={1500}
          transitionEnterTimeout={1500}
        >
          {navigation ? (
            <StyledDiv className="revieve-backandreset">
              <StyledBackIcon onClick={prevPage}>
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16">
                  <path
                    fill="#FFF"
                    d="M50.4066281,29.1952949 L32.7326226,29.1952949 L38.4835815,23.3906891 C38.6978135,23.1890415 38.7849239,22.8865549 38.7107515,22.6018522 C38.6365791,22.3171496 38.4129487,22.095619 38.127559,22.0241357 C37.8421693,21.9526524 37.5405179,22.0426126 37.3409003,22.2587373 L30.2326723,29.4340241 C29.9224426,29.7475738 29.9224426,30.2524262 30.2326723,30.5659759 L37.3409003,37.7412627 C37.5405179,37.9573874 37.8421693,38.0473476 38.127559,37.9758643 C38.4129487,37.904381 38.6365791,37.6828504 38.7107515,37.3981478 C38.7849239,37.1134451 38.6978135,36.8109585 38.4835815,36.6093109 L32.7326226,30.8047051 L50.4066281,30.8047051 C50.6941215,30.8047051 50.9597764,30.6513292 51.1035231,30.4023525 C51.2472698,30.1533759 51.2472698,29.8466241 51.1035231,29.5976475 C50.9597764,29.3486708 50.6941215,29.1952949 50.4066281,29.1952949 Z"
                    transform="translate(-30 -22)"
                  />
                </svg>
                {navigationText && <div> &nbsp; {t(navigationText)}</div>}
              </StyledBackIcon>
              <StyledResetButton className="revieve-startOver" onClick={startOver}>
                {t('start_over')}
              </StyledResetButton>
            </StyledDiv>
          ) : null}
        </ReactCSSTransitionGroup>
      </StyledWrapper>
    );
  };
}

export default translate()(Header);



// WEBPACK FOOTER //
// ./src/components/instore/Header.js